module.exports = __webpack_public_path__ + "static/media/footer-phone.530b3acc.svg";